// src/services/authService.ts
import api from './api';

export const login = async (credentials) => {
  try {
    console.log("Tentative de login avec credentials =", credentials);
    const response = await api.post('/auth/login', credentials);
    console.log("Réponse login:", response.data);
    console.log("Données envoyées au backend:", credentials);

    localStorage.setItem('token', response.data.access_token);

    const userData = {
      id: response.data.user_id,
      name: response.data.name,
      email: response.data.email || null,
      phone: response.data.phone || null,
      is_farmer: response.data.is_farmer,
      is_customer: response.data.is_customer,
      is_admin: response.data.is_admin
    };

    localStorage.setItem('user', JSON.stringify(userData));

    return {
      ...response.data,
      user: userData
    };
  } catch (error) {
    console.error("Erreur login:", error);
    throw error;
  }
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log("Pas de token disponible pour /auth/me");
      return null;
    }

    const response = await api.get('/auth/me');
    return response.data;
  } catch (error) {
    console.error("Erreur getCurrentUser:", error);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

export const getStoredUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const resetPassword = async (token, newPassword) => {
  const response = await api.post('/auth/reset-password', {
    token,
    new_password: newPassword
  });
  return response.data;
};

export const forgotPassword = async (contact) => {
  const response = await api.post('/auth/forgot-password', { contact });
  return response.data;
};